import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import { formatAmount, formatPhone } from '@/lib/utils/formatters'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display, makeLink, formatDate } from '../../utils/configuredReportFormatters'

export const claimNotTimelyColumns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] = [
  {
    id: 'applicant_id',
    label: 'Applicant',
    sortKey: 'applicant_id',
    render: (row) =>
      row.applicant_id && row.user_id
        ? makeLink(
            `/resident/resident-detail/${row.applicant_id}/${row.user_id}`,
            display(row.applicant_id),
            true,
          )
        : display(row.applicant_id),
  },
  {
    id: 'resident_name',
    label: 'Resident',
    sortKey: 'resident_name',
    render: (row) => display(row.resident_name),
  },
  {
    id: 'property_name',
    label: 'Property',
    sortKey: 'property_name',
    render: (row) =>
      row.property_id
        ? makeLink(
            `/property/edit/${row.property_id}`,
            display(row.property_name),
            true,
          )
        : display(row.property_name),
  },
  {
    id: 'property_contact_phone',
    label: 'Phone',
    sortKey: 'property_contact_phone',
    render: (row) =>
      formatPhone(String(row.property_contact_phone ?? '')) || '—',
  },
  {
    id: 'property_state',
    label: 'State',
    sortKey: 'property_state',
    render: (row) => display(row.property_state),
  },
  {
    id: 'company_name',
    label: 'Company',
    sortKey: 'company_name',
    render: (row) => display(row.company_name),
  },
  {
    id: 'lease_start_date',
    label: 'Lease Start',
    sortKey: 'lease_start_date',
    render: (row) => formatDate(row.lease_start_date),
  },
  {
    id: 'lease_end_date',
    label: 'Lease End',
    sortKey: 'lease_end_date',
    render: (row) => formatDate(row.lease_end_date),
  },
  {
    id: 'rent_amount',
    label: 'Rent Amount',
    sortKey: 'rent_amount',
    render: (row) => formatAmount(row.rent_amount as string | number),
  },
  {
    id: 'last_reminder_email_date',
    label: 'Last Reminder Email',
    sortKey: 'last_reminder_email_date',
    render: (row) => formatDate(row.last_reminder_email_date),
  },
  {
    id: 'last_marked_date',
    label: 'Last Marked Date',
    sortKey: 'last_marked_date',
    render: (row) =>
      row.last_marked_date ? formatDate(row.last_marked_date) : 'Not Marked',
  },
  {
    id: 'last_marked_status',
    label: 'Last Marked Status',
    sortKey: 'last_marked_status',
    render: (row) =>
      display(row.last_marked_status) === '—'
        ? 'Not Marked'
        : display(row.last_marked_status),
  },
]
